import { destroy, get, post, put } from '.';

export const getMarkets = ({ filters }) => post(`markets/list`, filters);
export const getOneMarket = ({ marketId }) => get(`markets/${marketId}`);
export const createMarkets = payload => post(`markets`, payload);
export const updateMarket = (marketId, payload) =>
  put(`markets/${marketId}`, payload);
export const archiveMarket = marketId => destroy(`markets/${marketId}`);
